import React from 'react';
import { Table, Button, Popconfirm, Breadcrumb, Form, Divider, message } from 'antd';
import { defaultPageSize, api, onGet, onPost } from '../../../../core/api3';
import QuantRobotEditModal from './QuantRobotEditModal';

const { Column } = Table;

class QuantRobotView extends React.Component {

    constructor() {
        super();
        this.state = {
            quantRobotStrategys: [],
            quantRobots: [],
            pageNumber: 1,
            pageSize: defaultPageSize,
            totalPage: 0,
            totalRow: 0,
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalFinish = this.onModalFinish.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        onGet(api.listQuantRobotStrategy.url).then(response => {
            if (response === undefined) {
                return;
            }
            this.setState({
                quantRobotStrategys: response
            });
            onGet(api.listQuantRobot.url, api.listQuantRobot.params(this.state.pageNumber, this.state.pageSize)).then(response => {
                if (response === undefined) {
                    return;
                }
                response.dataList.forEach(quantRobot => {
                    quantRobot.key = quantRobot.id;
                    let statusStr = ['未运行', '运行中', '停止中'];
                    quantRobot.statusStr = statusStr[quantRobot.status];
                    if (quantRobot.profit === undefined) {
                        quantRobot.profit = '0';
                    } else {
                        quantRobot.profit = quantRobot.profit.toFixed(4);
                    }
                    if (quantRobot.lastRunTime === undefined) {
                        quantRobot.lastRunTime = '还未运行过';
                    }
                });
                this.setState({
                    quantRobots: response.dataList,
                    totalPage: this.state.pageNumber,
                    totalRow: response.dataSize
                });
            });
        });
    }

    onChangePage(pageNumber) {
        this.setState({ pageNumber: pageNumber }, () => {
            this.loadData();
        });
    }

    onClick(type, item) {
        switch (type) {
            case 'add':
                this.setState({ modalVisible: true });
                break;
            case 'detail':
                this.props.history.push('/coin/quantRobot/detail?robotId=' + item.key);
                break;
            case 'delete':
                onPost(api.deleteQuantRobot.url, api.deleteQuantRobot.params(item.key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('删除成功');
                    this.loadData();
                });
                break;
            case 'start':
                onPost(api.startRobot.url, api.startRobot.params(item.key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('启动成功');
                    this.loadData();
                });
                break;
            case 'stop':
                onPost(api.stopRobot.url, api.stopRobot.params(item.key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('停止成功');
                    this.loadData();
                });
                break;
            default:
                break;
        }
    }

    onModalClose() {
        this.setState({ modalVisible: false });
    }

    onModalFinish() {
        this.setState({ modalVisible: false }, () => {
            this.loadData();
        });
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item>量化实盘</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content">
                    <Button type="primary" style={{ marginBottom: 20 }} onClick={() => this.onClick('add')}>添加</Button>
                    <Table dataSource={this.state.quantRobots} pagination={{
                        current: this.state.pageNumber, total: this.state.totalRow, defaultPageSize: this.state.pageSize,
                        onChange: pageNumber => { this.onChangePage(pageNumber) }
                    }}>
                        <Column title="实盘名称" dataIndex="name" align="center" />
                        <Column title="实盘策略" dataIndex="strategyDescribe" align="center" />
                        <Column title="实盘状态" align="center" render={item => (
                            <span style={item.status !== 0 ? { color: '#FF0000' } : {}}>{item.statusStr}</span>
                        )} />
                        <Column title="当前收益" dataIndex="profit" align="center" />
                        <Column title="添加时间" dataIndex="createTime" align="center" />
                        <Column title="最后运行时间" dataIndex="lastRunTime" align="center" />
                        <Column title="操作" align="center" render={item => (
                            <span>
                                <Popconfirm title="确定要启动实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('start', item)}>
                                    <a hidden={item.status !== 0}>启动</a>
                                </Popconfirm>
                                <Divider type="vertical" hidden={item.status !== 0} />
                                <Popconfirm title="确定要停止实盘？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('stop', item)}>
                                    <a hidden={item.status !== 1}>停止</a>
                                </Popconfirm>
                                <Divider type="vertical" hidden={item.status !== 1} />
                                <a onClick={() => this.onClick('detail', item)} >详情</a>
                                <Divider type="vertical" />
                                <Popconfirm title="确定要删除这条记录？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('delete', item)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )} />
                    </Table>
                </div>
                {this.state.modalVisible &&
                    <QuantRobotEditModal quantRobotStrategys={this.state.quantRobotStrategys} onModalCancel={this.onModalClose} onModalFinish={this.onModalFinish} />
                }
            </div>
        );
    }

}

const QuantRobotPage = Form.create()(QuantRobotView);
export default QuantRobotPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotPage.jsx